// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604290657/js/" + chunkId + "." + {"44":"2d337c1b","225":"2ea9d217","481":"7d9ef397","486":"7720808a","770":"b8e73525"}[chunkId] + ".0.44466519090344203.chunk.js";
};